import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const ModalAlertOfRole = ({ open, setOpen }) => {
  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: "#b26a00", // tono naranja advertencia
          fontWeight: "bold",
        }}
      >
        <WarningAmberRoundedIcon sx={{ color: "#ff9800" }} />
        Sección no editable
      </DialogTitle>

      <DialogContent>
        <Box sx={{ paddingY: 1 }}>
          <Typography variant="body1" sx={{ marginBottom: 1 }}>
            Esta sección contiene información sensible relacionada con los roles
            del sistema.
          </Typography>
          <Typography variant="body1">
            Por motivos de seguridad, no es posible modificar estos datos
            directamente. Si necesitas hacer cambios, por favor contacta al
            soporte técnico.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          variant="contained"
          sx={{
            backgroundColor: "#ffb74d",
            color: "#000",
            "&:hover": {
              backgroundColor: "#ffa726",
            },
          }}
        >
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAlertOfRole;
